export default "__VITE_PUBLIC_ASSET__ad7a9b8a__"